/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Profile_Editors_Bodyfat_SavedInputs */

const en_us2_profile_editors_bodyfat_saved = /** @type {(inputs: Profile_Editors_Bodyfat_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Measurement logged: ${i?.value}%`)
};

const pt_br2_profile_editors_bodyfat_saved = /** @type {(inputs: Profile_Editors_Bodyfat_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Medida registrada: ${i?.value}%`)
};

const es_419_profile_editors_bodyfat_saved = /** @type {(inputs: Profile_Editors_Bodyfat_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Medición registrada: ${i?.value}%`)
};

const pt_pt2_profile_editors_bodyfat_saved = /** @type {(inputs: Profile_Editors_Bodyfat_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Medição registada: ${i?.value}%`)
};

const fr_fr2_profile_editors_bodyfat_saved = /** @type {(inputs: Profile_Editors_Bodyfat_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mesure enregistrée : ${i?.value} %`)
};

const de_de2_profile_editors_bodyfat_saved = /** @type {(inputs: Profile_Editors_Bodyfat_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Messung erfasst: ${i?.value}%`)
};

const it_it2_profile_editors_bodyfat_saved = /** @type {(inputs: Profile_Editors_Bodyfat_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Misurazione registrata: ${i?.value}%`)
};

/**
* | output |
* | --- |
* | "Measurement logged: {value}%" |
*
* @param {Profile_Editors_Bodyfat_SavedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_bodyfat_saved = /** @type {((inputs: Profile_Editors_Bodyfat_SavedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Bodyfat_SavedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_bodyfat_saved(inputs)
	if (locale === "es-419") return es_419_profile_editors_bodyfat_saved(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_bodyfat_saved(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_bodyfat_saved(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_bodyfat_saved(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_bodyfat_saved(inputs)
	return en_us2_profile_editors_bodyfat_saved(inputs)
});
export { profile_editors_bodyfat_saved as "profile-editors.bodyfat_saved" }